import { Meeting_Step_Type_Enum } from '@gql'

// The aids of a meeting step (#136), in the order of their icons
export type MeetingStepAidRole =
  'facilitation' | 'secretary' | 'participants' | 'know'

const Step = Meeting_Step_Type_Enum

/**
 * Which aids each step type has, written from the Université du Nous sheets
 * (triage, governance, objections — CC BY-SA) and reviewed by Yohan (26/09).
 * A free note and the next steps have none (Yohan: « on ne sait pas encore
 * comment cette étape est prise en main »); the closing tour has no
 * facilitation aid, which belongs to the Debrief step (#74).
 */
export const meetingStepAids: Partial<
  Record<Meeting_Step_Type_Enum, MeetingStepAidRole[]>
> = {
  [Step.Inclusion]: ['facilitation', 'secretary', 'participants'],
  [Step.Checklist]: ['facilitation', 'secretary', 'participants', 'know'],
  [Step.Indicators]: ['facilitation', 'secretary', 'participants', 'know'],
  [Step.Tasks]: ['facilitation', 'secretary', 'participants', 'know'],
  [Step.Threads]: ['facilitation', 'secretary', 'participants', 'know'],
  [Step.ThreadsGovernance]: ['facilitation', 'secretary', 'participants'],
  [Step.Declusion]: ['secretary', 'participants'],
}
